import useUserName from '../../common/hooks/useUserName';

import './user.css';
export default function User() {
    const { userName } = useUserName();

    return (
        <h6 className="userName">Welcome, {userName}</h6>
    );
}